/** Publication status of a news feed post. No scheduling, no archive in v1. */
export enum PostStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

/** A post counts as `New` while it was published within this window. */
export const NEW_POST_WINDOW_DAYS = 7;

export const DEFAULT_POST_PAGE_SIZE = 10;

/** Slides in the top-news carousel. Not paginated — this is the hard limit. */
export const CAROUSEL_POST_COUNT = 8;

/**
 * Posts in the latest-posts widget on the homepage. Not paginated — this is
 * the hard limit; the full list lives at `/feed`.
 */
export const LATEST_POST_COUNT = 10;

/**
 * Only posts published within this window can enter the carousel.
 *
 * Likes are cumulative and unbounded: without a window an old post would
 * outrank everything recent forever, and the carousel would calcify into a
 * fixed set that new content could never enter.
 */
export const CAROUSEL_WINDOW_DAYS = 30;
